export const copyToClipboard = (text) => {
  if (window.clipboardData && window.clipboardData.setData) {
    return window.clipboardData.setData('Text', text)
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    var textarea = document.createElement('textarea')
    textarea.textContent = text
    textarea.style.position = 'fixed'  // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand('copy')  // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex)
      return false
    } finally {
      document.body.removeChild(textarea)
    }
  }
}

export const userHasRole = (userRoles, role) => {
  if (!userRoles || !role) return false
  return (userRoles.indexOf(role) !== -1)
}

export const userHasAnyOfRoles = (userRoles, roles) => {
  return userRoles && roles && roles.some(role => userHasRole(userRoles, role))
}

export default {
  copyToClipboard,
  userHasRole,
  userHasAnyOfRoles
}



// WEBPACK FOOTER //
// ./src/services/helper.js